/**
 * <roots-reel>: a muted, looping vertical video that plays while it is on screen.
 * Owner, 2026-09-28: autoplay when visible, loop, no audio, no control buttons; click or tap
 * pauses and resumes. A pause the visitor chose sticks until they tap again. Reduced motion
 * never autoplays: the poster shows and a tap starts it.
 * A custom element, so Theme Editor re-renders don't stack listeners.
 */
if (!customElements.get('roots-reel')) {
  customElements.define(
    'roots-reel',
    class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('.lot-stop__reel-toggle');
        if (!this.video || !this.toggle) return;

        Object.assign(this.video, { muted: true, loop: true, playsInline: true, controls: false });
        this.userPaused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.label();

        this.onClick = () => {
          this.userPaused = !this.video.paused;
          this.userPaused ? this.video.pause() : this.play();
        };
        this.toggle.addEventListener('click', this.onClick);
        this.video.addEventListener('play', () => this.label());
        this.video.addEventListener('pause', () => this.label());

        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting && !this.userPaused) this.play();
            else if (!entry.isIntersecting) this.video.pause();
          },
          { threshold: 0.4 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.toggle?.removeEventListener('click', this.onClick);
      }

      play() {
        this.video.play().catch(() => {});
      }

      label() {
        const playing = !this.video.paused;
        this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pause : this.toggle.dataset.play);
        this.toggle.setAttribute('aria-pressed', String(!playing));
      }
    }
  );
}
